import React, { useCallback, useState } from 'react';
import { AppButton, Box, ButtonResponsiveWrapper, Preloader, useResponsive } from '@common-fe/common-fe';

import { WarnModal } from '@/components/elements';

import { useDeleteLMN } from '../hooks';
import { LettersOfMedicalNecessity } from '../LettersOfMedicalNecessity.types';

interface Props {
  deletedItem?: LettersOfMedicalNecessity;
  onSetId: (id: string) => void;
}
const LettersOfMedicalNecessityDeleteModal: React.FC<Props> = ({ deletedItem, onSetId }) => {
  const { isMobile } = useResponsive();
  const { loading, handleConfirm } = useDeleteLMN({
    item: deletedItem,
    onSuccess: () => {
      onSetId('');
    },
    onError: () => {
      setErrorModalVisible(true);
    },
  });

  const [errorModalVisible, setErrorModalVisible] = useState(false);

  const handleClose = useCallback(() => {
    onSetId('');
  }, [onSetId]);

  if (!deletedItem) return null;

  return (
    <>
      <WarnModal
        testId="letter-of-medical-necessity-delete"
        visible={!!deletedItem && !errorModalVisible}
        header="Delete this Letter of Medical Necessity?"
        onSetVisible={handleClose}
        cancelButtonNode={
          <ButtonResponsiveWrapper fill={isMobile}>
            <AppButton
              fill={isMobile}
              testId="letter-of-medical-necessity-delete_cancel"
              buttonType="secondary"
              onClick={handleClose}
              width="150px"
              disabled={loading}
            >
              Cancel
            </AppButton>

            <AppButton
              fill={isMobile}
              testId="letter-of-medical-necessity-delete_apply"
              color="red"
              onClick={handleConfirm}
              width="150px"
              disabled={loading}
            >
              {loading ? <Preloader color="white" /> : 'Yes, Delete'}
            </AppButton>
          </ButtonResponsiveWrapper>
        }
      />

      {/* Error Modal */}
      <WarnModal
        visible={errorModalVisible}
        header="Can't Delete LMN"
        helptext="You can’t delete this LMN because it is associated with an approved claim."
        onSetVisible={() => {
          setErrorModalVisible(false);
          handleClose();
        }}
        cancelButtonNode={
          <Box fill={isMobile} margin={{ left: 'auto', right: 'auto' }}>
            <AppButton
              fill={isMobile}
              buttonType="primary"
              onClick={() => {
                setErrorModalVisible(false);
                handleClose();
              }}
              width="150px"
            >
              Close
            </AppButton>
          </Box>
        }
      />
    </>
  );
};

export default LettersOfMedicalNecessityDeleteModal;
